<template>
  <!-- 全页面LOADING -->
  <div class="MIDAS-MOBILE-loading">
    <div class="MIDAS-MOBILE-loading__main">
      <div class="MIDAS-MOBILE-loading__logo">
        <i class="logo_txcz"></i>
      </div>
      <p class="MIDAS-MOBILE-loading__txt">收银姐姐马上就来....</p>
    </div>
  </div>
</template>
<script>
export default {}
</script>
